import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "@/store/store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";


// セレクションの拡張マスタ情報 todo セット対応時にちゃんと実装する


@Module({
    name: "SelectionsStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class SelectionsStore extends VuexModule {
    // state
    private _apiResponse: CMS.Selection[] = [];
    private _selectionById: { [id: number]: CMS.Selection } = {};

    // getter
    get all(): CMS.Selection[] {
        return this._apiResponse || [];
    }

    get selectionById(): { [id: number]: CMS.Selection } {
        return this._selectionById;
    }

    @Action
    public async init() {
        const response: CMS.Selection[] = (await CmsApiClient.getSelections());
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setSelectionById(response[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = [];
        this._selectionById = {};
    }

    @Mutation
    private setResponse(response: CMS.Selection[]) {
        this._apiResponse = response;
    }

    @Mutation
    private setSelectionById(selection: CMS.Selection): void {
        Vue.set(this._selectionById, selection.selection_id, selection);
    }
}

export default getModule(SelectionsStore);
